import { DateTimePicker } from '@mantine/dates';
import type { DateTimePickerProps } from '@mantine/dates';
import './DateTimeInput.css';

export interface DateTimeInputProps extends DateTimePickerProps {}

export default function DateTimeInput({
  className = '',
  valueFormat = 'DD.MM.YYYY HH:mm',
  popoverProps,
  ...props
}: DateTimeInputProps) {
  return (
    <DateTimePicker
      className={`custom-datetime-input ${className}`.trim()}
      valueFormat={valueFormat}
      popoverProps={{ zIndex: 1100, withinPortal: true, ...popoverProps }}
      {...props}
    />
  );
}
